// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__URsl7","col":"styles_col__3JOUH"};